<template>
    <div class="tab">
        <div>
            <div @click="goRouter('/')" :class="$route.name=='Home'?'active':''">首 页</div>
            <div @click="goRouter('/product')" :class="$route.name=='Product'?'active':''">产品分类</div>
            <div @click="goRouter('/product_shop')" :class="$route.name=='ProductShop'?'active':''">产品列表</div>
            <div @click="goRouter('/shop_auction')" :class="$route.name=='ShopAuction'?'active':''">竞 拍</div>
            <div @click="goRouter('/shop_yxmh')" :class="$route.name=='ShopYXMH'?'active':''">意向卖货</div>
            <div @click="goRouter('/notice')" :class="$route.name=='Notice'?'active':''">公告通知</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Tab",
        data() {
            return {}
        },
        methods: {}
    };
</script>

<style scoped>
    .tab {
        height: 54px;
        background: linear-gradient(90deg, #D50000 0%, #FF6969 100%);
        line-height: 54px;
        color: #FFFFFF;
        font-size: 18px;
    }

    .tab>div {
        width: 1200px;
        margin: 0 auto;
        display: flex;
    }

    .tab>div>div {
        width: 140px;
        cursor: pointer;
    }

    .tab>div>.active {
        background: #B80E0E;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tab.vue